module.exports = __webpack_public_path__ + "static/media/german_pontoon_bridge.eaeb77cb.jpg";